// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import store from "@/store/index";
import SIdentify from "@/view/login/identify"; //注意引入路径
import * as echarts from "echarts";
import VueClipboard from "vue-clipboard2";
import jquery from "jquery";
import "@/icons";
import "@/style/style.css";
import IconSvg from "./components/SvgIcon";
import VueCropper from "vue-cropper";
import VueResource from "vue-resource";
import pinyin from "js-pinyin";
import filters from "@/filters/index";
import "babel-polyfill";
import vueToPdf from "vue-to-pdf";
import x2js from "x2js"; //xml数据处理插件
import vcolorpicker from "vcolorpicker";
Vue.use(vcolorpicker);
Vue.prototype.$x2js = new x2js(); //创建x2js对象，挂到vue原型上

// import VueEasyPrinter from 'vue-easy-printer';
// import htmlToPdf from '@/components/utils/htmlToPdf';
Vue.use(vueToPdf);

// Vue.use(VueEasyPrinter);
// Vue.use(htmlToPdf);
Vue.directive("title", {
  inserted: function(el, binding) {
    document.title = el.dataset.title;
  }
});

Vue.use(VueResource);
Vue.use(VueCropper);
Vue.component("svg-icon", IconSvg);
Vue.prototype.$echarts = echarts;
Vue.use(SIdentify);
Vue.use(VueClipboard);
Vue.use(ElementUI);

Object.keys(filters).forEach(filterName => {
  Vue.filter(filterName, filters[filterName]);
});

Vue.config.productionTip = false;
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded";
axios.defaults.transformRequest = [
  function(data) {
    let ret = "";
    for (let it in data) {
      ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
    }
    return ret;
  }
];
Vue.prototype.tokenInvalid = function(res) {
  //tokenInvalid是函数名
  if (res.data.code == 300) {
    this.$alert("当前登录已失效，请重新登录", {
      confirmButtonText: "确定",

      type: "error",
      center: true
    })
      .then(() => {
        this.$router.push("/login");
        return;
      })
      .catch(() => {
        return;
      });
  }
};

axios.defaults.baseURL = "/api";
Vue.prototype.$axios = axios;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  axios,
  store,
  jquery,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js